import { Switch, View } from "react-native";
import React from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { toggleThemeAction } from "../redux/slices/authSlice";

export const ThemeToggleSwitch = () => {
  const theme = useAppSelector((state) => state.auth.theme);
  const dispatch = useAppDispatch();

  const toggleTheme = () => {
    dispatch(toggleThemeAction());
  };

  return (
    <View>
      <Switch value={theme === "light"} onValueChange={toggleTheme} />
    </View>
  );
};
